import { connect } from "react-redux";

import { selectMaterialById } from "~/store/ducks/application/materials/materials";
import { selectIsEditMode } from "~/store/ducks/application/materials/isEditMode";
import { switchModal, showModal } from "~/store/ducks/domain/ui/modal";

import ShowMaterialModal from "./ShowMaterialModal";

const mapStateToProps = (state, ownProps) => ({
  isEditMode: selectIsEditMode(state),
  material: selectMaterialById(ownProps.id)(state)
});

const mapDispatchToProps = {
  switchModal,
  showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowMaterialModal);
